module.exports = __webpack_public_path__ + "img/screwdriver.c4b6ac90.jpg";